import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';

@Component({
    selector: 'nova-more-options-menu',
    template: ` <a
            #menuTrigger
            class="trigger"
            href="javascript:void(0);"
            (click)="$event.stopPropagation()"
            [matMenuTriggerFor]="moreOptionsMenu">
            <mat-icon
                class="material-icons"
                [inline]="true"
                >{{ matIconName }}</mat-icon
            >
        </a>
        <mat-menu
            #moreOptionsMenu="matMenu"
            [overlapTrigger]="false">
            <div class="items">
                <ng-content></ng-content>
            </div>
        </mat-menu>`,
    styles: [
        `
            .trigger {
                font-size: 14px;
            }
        `,
        `
            .items {
                padding: 0px 8px 0px 8px;
            }
        `
    ],
    standalone: true,
    imports: [MatIconModule, MatMenuModule]
})
export class MoreOptionsMenuComponent {
    @Input() matIconName = 'more_vert';
}
